<template>
    <p>Organization Dashboard</p>
</template>

<script>
    export default {
        name: 'OrganizationProfiler',
    }
</script>

<style scoped>

</style>